import * as React from "react";
import { SVGProps } from "react";

const Polyswarm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1994 1915" {...props}>
    <path
      fill="#8500ff"
      d="M216.46 509.2h997.76c149.32 0 270.8 121.48 270.8 270.8s-121.48 270.8-270.8 270.8H674.34a77.1 77.1 0 0 0 0 154.2h539.86c234.34 0 425-190.63 425-425s-190.66-425-425-425H216.46a77.1 77.1 0 0 0 0 154.2Z"
    />
    <path
      fill="#8500ff"
      d="M1214.22 0h-387a77.1 77.1 0 0 0 0 154.2h387C1559.29 154.2 1840 434.93 1840 780s-280.73 625.81-625.8 625.81h-983a77.09 77.09 0 1 0 0 154.17h983c430.09 0 780-349.9 780-780S1644.32 0 1214.22 0Z"
    />
    <path
      fill="#8500ff"
      d="M767.22 780a77.19 77.19 0 0 0-77.1-77.1h-187.9a77.19 77.19 0 0 0-77.1 77.1c0 42.71 34.1 77.1 62.32 77.1h187.88c54.12 0 91.9-31.71 91.9-77.1Zm-244.05 980.83H77.1a77.1 77.1 0 1 0 0 154.19h446.07a77.1 77.1 0 1 0 0-154.19Z"
    />
  </svg>
);

export default Polyswarm;
